module.exports = __webpack_public_path__ + "assets/img/oseShop.38d0629e.png";